import React, { FC, memo, useCallback, useContext } from "react";
import { useEffectOnce } from "@swiggy-private/core-ui";
// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
// utils
import { isEmpty } from "@swiggy-private/js-utils";
// constants
import { CTA } from "@super-ui/components/m2c-swiggy-one-halfcard/types";
import { M2C_HALFCARD_TEST_IDS } from "@super-ui/components/m2c-swiggy-one-halfcard/constants";
// styles
import { CtaContainer, PrimaryButton, SkipButton } from "../styles";
// contexts
import { M2CHalfcardContext } from "@super-ui/contexts";

interface CTAProps {
    ctas: CTA[];
    addSuperFromTGBottomsheet: (ctaText: string) => void;
    closeBottomSheet: (ctaText: string) => void;
    addingSuperToCart: boolean;
    setAddingSuperToCart: (addingSuperToCart: boolean) => void;
}

const PreStateCtas: FC<CTAProps> = ({
    ctas = [],
    addSuperFromTGBottomsheet,
    closeBottomSheet,
    addingSuperToCart,
    setAddingSuperToCart,
}) => {
    const [addCta, skipCta] = ctas;
    const {
        analyticsEvents: { onImpressionM2CHalfcardAddCta, onImpressionM2CHalfcardSkipCta },
    } = useContext(M2CHalfcardContext);

    useEffectOnce(() => {
        onImpressionM2CHalfcardAddCta(addCta?.text || "");
        onImpressionM2CHalfcardSkipCta(skipCta?.text || "");
    });

    const primaryCtaAction = useCallback(() => {
        setAddingSuperToCart(true);
        addSuperFromTGBottomsheet(addCta?.text || "");
    }, [addCta?.text, addSuperFromTGBottomsheet, setAddingSuperToCart]);

    return (
        <CtaContainer>
            {!isEmpty(addCta?.text) && (
                <PrimaryButton
                    data-testid={M2C_HALFCARD_TEST_IDS.PRIMARY_CTA}
                    variant="fullwidth"
                    buttonType="primary"
                    buttonSize="large"
                    onClick={primaryCtaAction}
                    loading={addingSuperToCart}
                >
                    <Text variant="V2.subheading1.neutral.bold" color="text_inverse_Highest_Emphasis">
                        {addCta?.text}
                    </Text>
                </PrimaryButton>
            )}
            {!isEmpty(skipCta?.text) && (
                <SkipButton
                    onClick={() => closeBottomSheet(skipCta?.text || "")}
                    data-testid={M2C_HALFCARD_TEST_IDS.SECONDARY_CTA}
                >
                    {/* adding hardcoded color to avoid theme change in IM as design requirement */}
                    <Text variant="V2.subheading1.neutral.bold" customColor={{ light: "#FF5200", dark: "#FF5200" }}>
                        {skipCta?.text}
                    </Text>
                </SkipButton>
            )}
        </CtaContainer>
    );
};

export default memo(PreStateCtas);
